import React from 'react';
import { Route } from 'react-router-dom';
import PropTypes from 'prop-types';
import VerifierDroitsComponent from '../VerifierDroits/VerifierDroitsComponent';

const RouteSecurisee = ({ path, render, droits, exact }) => {
    return (
        <VerifierDroitsComponent droits={droits}>
            <Route path={path} render={render} exact={exact} />
        </VerifierDroitsComponent>
    );
};

RouteSecurisee.propTypes = {
    path: PropTypes.string.isRequired,
    render: PropTypes.any.isRequired,
    exact: PropTypes.bool,
    droits: PropTypes.array.isRequired,
};

RouteSecurisee.defaultProps = {
    exact: false,
};

export default RouteSecurisee;
